import { render } from "./OrdForSupplierTemplate.vue?vue&type=template&id=7403f531"
import script from "./OrdForSupplierTemplate.vue?vue&type=script&lang=js"
export * from "./OrdForSupplierTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__